export class League {
    constructor(
        id,
        name,
        country,
    ) {
        this.id = id;
        this.name = name;
        this.country = country;
    }
}